import { render, staticRenderFns } from "./RegisterBirthdate.vue?vue&type=template&id=cff1d4ec"
import script from "./RegisterBirthdate.vue?vue&type=script&lang=js"
export * from "./RegisterBirthdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports